import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import VersionListContainer from '../../containers/version/VersionListContainer';
import { VERSION_PAGE_NAME } from '../../constants/service/app/versionConstants';

const VersionList = () => {
  return (
    <PageTemplate pageName={VERSION_PAGE_NAME.VERSION_LIST}>
      <VersionListContainer pageName={VERSION_PAGE_NAME.VERSION_LIST} />
    </PageTemplate>
  );
};

export default VersionList;
